/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import { useToken } from "hooks/use-token";
import sweetAlert from "components/sweet-alert";

const AuthContext = React.createContext({
  accessToken: "",
  accessTokenExpiry: "",
  refreshToken: "",
  refreshTokenExpiry: "",
  isLoggedIn: false,
  login: (
    accessToken,
    accessTokenExpiry,
    refreshToken,
    refreshTokenExpiry
  ) => {},
});

export default AuthContext;

export function AuthContextProvider(props) {
  const [token, setToken] = useToken();
  const [refreshToken, setRefreshToken] = useState("");
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
  let sessionExpiryTimer = null;
  let toastTimer = null;
  useEffect(() => {
    //call this function to start timer in case of refresh
    sessionExpiryTimeHandler();
    if (!token) {
      clearTimeout(sessionExpiryTimer);
      clearTimeout(toastTimer);

      return;
    }
    return () => {
      if (sessionExpiryTimer) {
        clearTimeout(sessionExpiryTimer);
      }
      if (toastTimer) {
        clearTimeout(toastTimer);
      }
    };
  }, []);

  const loginHandler = (
    accessToken,
    accessTokenExpiry,
    refreshToken,
    refreshTokenExpiry
  ) => {
    setUserIsLoggedIn(true);
    sessionStorage.setItem("auth-expiry-time", accessTokenExpiry);
    sessionStorage.setItem("refresh-expiry-time", refreshTokenExpiry);
    sessionStorage.setItem("refresh-token", refreshToken);
    setToken(accessToken);
    setRefreshToken(refreshToken);
    //call this function to start timer in case of login
    sessionExpiryTimeHandler();
  };

  const logoutHandler = () => {
    window.top.postMessage({ type: "logout" }, process.env.REACT_APP_ADMIN);
    setUserIsLoggedIn(false);
    sessionStorage.clear();
  };

  const contextValue = {
    token,
    refreshToken,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  function sessionExpiryTimeHandler() {
    if (sessionStorage.getItem("refresh-expiry-time")) {
      const expiryTime = new Date(
        sessionStorage.getItem("refresh-expiry-time")
      );

      const offset = expiryTime.getTimezoneOffset();

      // it is important to add offset because date() changing local date to utc and return it as utc
      const expiryTimeInMilliseconds = expiryTime.getTime() + offset * 60000;
      //get difference from current time in milliseconds because setTimeout accepts milliseconds
      const expiryDifference = expiryTimeInMilliseconds - new Date().getTime();
      // subtract 5 minutes from expiry time
      const showToastAfterTime = expiryDifference - 5 * 60000;
      const remainingTime = Math.floor(expiryDifference / 60000);
      console.log(
        "Session will expire in ",
        Math.floor(remainingTime),
        " minutes. We will show toast in",
        Math.floor(showToastAfterTime / 60000),
        "minutes"
      );
      if (expiryDifference <= 0) {
        sweetAlert({
          title: "Session Expiry",
          text: `Your Session has expired. Loging out...`,
          icon: "info",
        });
        logoutHandler();
      } else {
        sessionExpiryTimer = setTimeout(() => {
          logoutHandler();
        }, expiryDifference);

        toastTimer = setTimeout(() => {
          const expiryDifference =
            expiryTimeInMilliseconds - new Date().getTime();
          const remainingTime = Math.floor(expiryDifference / 60000);

          sweetAlert({
            title: "Session Expiry",
            text: `Your Session will expire in ${remainingTime} minutes! Please Save your work.`,
            icon: "info",
          });
          console.log(`Session Is Going To Expire In ${remainingTime} Minutes`);
        }, showToastAfterTime);
      }
    }
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
}
